/** App language → BCP 47 locale for number formatting. */
export function getAppNumberLocale(lang: string | null | undefined): string {
  return (lang || 'en').toLowerCase().startsWith('tr') ? 'tr-TR' : 'en-US';
}

/** Decimal separator for the active language: TR → `,` , EN → `.` */
export function getDecimalSeparator(lang: string | null | undefined): string {
  return getAppNumberLocale(lang) === 'tr-TR' ? ',' : '.';
}

/**
 * Format a number for display (no grouping).
 * TR: 0,2  |  EN: 0.2
 */
export function formatLocaleNumber(
  value: number | null | undefined,
  fractionDigits: number,
  lang: string | null | undefined
): string {
  if (value == null || !Number.isFinite(Number(value))) {
    return '';
  }
  return new Intl.NumberFormat(getAppNumberLocale(lang), {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping: false,
  }).format(Number(value));
}

/**
 * Parse user-entered text that may use `,` or `.` as decimal separator.
 */
export function parseLocaleNumber(text: string | null | undefined): number {
  if (text == null) {
    return NaN;
  }
  const trimmed = String(text).trim().replace(/\s/g, '');
  if (!trimmed) {
    return NaN;
  }

  const lastComma = trimmed.lastIndexOf(',');
  const lastDot = trimmed.lastIndexOf('.');
  let normalized = trimmed;

  if (lastComma > lastDot) {
    // 1.234,56 or 0,2
    normalized = trimmed.replace(/\./g, '').replace(',', '.');
  } else if (lastDot > lastComma) {
    // 1,234.56 or 0.2
    normalized = trimmed.replace(/,/g, '');
  } else if (lastComma >= 0) {
    normalized = trimmed.replace(',', '.');
  }

  return Number(normalized);
}
